module.exports = __webpack_public_path__ + "media/images/ohap_calendar_down_arrow-8c82925fe62ec29fbfaccc0469a22f84.png";